import { useQuery } from '@tanstack/react-query';

import { useAppState } from '../../AppStateProvider';
import { queryClient } from '../../queryClient';

import quotaApi from './api';
import quotaQueryKeys from './queryKeys';

export const useCompanyQuotaQuery = () => {
  const { isOpen } = useAppState();

  return useQuery({
    queryKey: quotaQueryKeys.company(),
    queryFn: async ({ signal }) => {
      return quotaApi.getCompanyQuota(signal);
    },
    enabled: isOpen,
  });
};

export const invalidateCompanyQuotaQuery = () => {
  queryClient
    .invalidateQueries({
      queryKey: quotaQueryKeys.company(),
    })
    .catch(console.error);
};
